export default "__VITE_ASSET__eda509b6__"